import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "@/components/site/SectionHead";
import { CallButton } from "@/components/site/Cta";
import { Reveal } from "@/components/site/Reveal";
import { FAQS } from "@/content/site";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative bg-[#0b0c0e] py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <SectionHead index="10" eyebrow="FAQ" lines={["Questions,", "answered"]} sub="Straight answers about our services, certifications and how to get started." />
          <div className="mt-8"><CallButton testId="faq-call">Talk to a Solar Expert</CallButton></div>
        </div>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-white/10">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-white/10" data-testid={`faq-accordion-item-${i}`}>
              <AccordionTrigger className="gap-6 py-6 text-left hover:no-underline [&>svg]:text-amber-400">
                <span className="flex gap-5">
                  <span className="font-mono text-xs text-zinc-500 pt-1">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-sans text-base sm:text-lg font-semibold tracking-normal text-white">{f.q}</h3>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pl-11 pr-8 text-base leading-relaxed text-zinc-300">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
